import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// AppSetUp - Get All (Read)
export const GetAll = createAsyncThunk(
  "ManagePickupDrop/new-entry",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ManagePickupDropAdmin.NewEntry}?name=${filter?.name ||
          ""}&vehicleNo=${filter?.vehicleNo || ""}&from=${filter?.from ||
          ""}&to=${filter?.to || ""}&todayFilter=${filter?.todayFilter ||
          ""}&service_type_id=${filter?.service_type_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const assignAmbassador = createAsyncThunk(
  "ManagePickupDrop/new-entry/assign-ambassador",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ManagePickupDropAdmin.NewEntry}/${id}`, {
        ambassador_id: data,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "new-entry",
  initialState: {
    data: null, // Store single record
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GetAll
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(assignAmbassador.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(assignAmbassador.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // const index = state.data.findIndex(
        //   (category) => category.id === action.payload?.data?.id
        // );
        // if (index !== -1) {
        //   state.data[index] = action.payload.data;
        // }
      })
      .addCase(assignAmbassador.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
